<script lang="ts">import { BannerFixed, BannerSwiper } from "@infinitro/banner-swiper";
import { CardSwiper } from "@infinitro/card-swiper";
import { fetchGameGroups, gameGroups } from "@infinitro/catalog-ex";
import { FeatureSet, ReleaseStage, stateFeatureSet, stateUi, wantAtLeastReleaseStage } from "@infinitro/config";
import { Container } from "@infinitro/container";
import { Toolbar } from "@infinitro/tab-category";
import { CasinoTopSection } from "@infinitro/top-section";
import { onMount } from "svelte";
let { groupSlug } = $props();
let showGameGroups = $derived($stateFeatureSet === FeatureSet.Preview && wantAtLeastReleaseStage(ReleaseStage.Alpha) && $stateUi.casinoLobby.showGameGroups === true);
onMount(() => {
	if (showGameGroups) fetchGameGroups("casino");
});
let group = $derived($gameGroups["casino"]?.find((g) => g.groupSlug === groupSlug));
let useDefault = $derived($stateUi.casinoLobby?.casinoLobbyStyle === "default");
let useAlternative2 = $derived($stateUi.casinoLobby?.casinoLobbyStyle === "alternative2");
let useAlternative4 = $derived($stateUi.casinoLobby?.casinoLobbyStyle === "alternative4");
</script>

<div class="game-group-container-general">
	<Container>
		<div class="game-group-container">
			{#if useAlternative4}
				<div class="section">
					<BannerFixed />
				</div>
			{:else}
				<div class="section no-mt">
					{#if useDefault || useAlternative2}
						<CasinoTopSection />
					{:else}
						<BannerSwiper showRightSideOfImage={true} />
					{/if}
				</div>
			{/if}
			<div class="section section2">
				<Toolbar activeTab={groupSlug} />
			</div>
			{#if showGameGroups && group}
				<div class="section card-section">
					<CardSwiper
						data={group.games}
						title={group.name}
						icon={group.iconUrl}
						iconSize={20}
						url={'#'}
						titleNotClickable={true}
						noViewAllLink={true}
						irregular={true}
						minHeight={true}
					/>
				</div>
			{:else}
				<div class="no-games">No games found</div>
			{/if}
		</div>
	</Container>
</div>

<style>
	.game-group-container-general {

    display: flex;

    width: 100%;

    max-width: 1232px;

    flex-direction: column;

    align-items: center
}

	.game-group-container {

    display: flex;

    width: 100%;

    flex-direction: column
}

	.no-games {

    grid-column: 1 / -1;

    width: 100%;

    text-align: center;

    font-size: 1.125rem;

    line-height: 1.75rem;

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

	.section {

    margin-bottom: 0px;

    margin-top: 0px
}

	@media (min-width: 1024px) {

    .section {

        margin-bottom: 0.5rem;

        margin-top: 0.5rem
    }
}

	.section2 {

    margin-bottom: 0px
}

	.no-mt {

    margin-top: 0px
}

	.card-section {

    margin-bottom: 0px;

    margin-top: 0px
}

	@media (min-width: 1024px) {

    .card-section {

        margin-bottom: 0.5rem;

        margin-top: 0.5rem
    }
}
</style>
